import { render, staticRenderFns } from "./USDT.vue?vue&type=template&id=078d39a3&scoped=true"
import script from "./USDT.vue?vue&type=script&lang=js"
export * from "./USDT.vue?vue&type=script&lang=js"
import style0 from "./USDT.vue?vue&type=style&index=0&id=078d39a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d39a3",
  null
  
)

export default component.exports